<div class="shape tone-shape" [class.classic]="isClassicStyle()">
  <svg class="shape-svg" viewBox="0 0 58 50" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
    <polygon points="29,0 0,50 29,50" [attr.fill]="leftFill()" />
    <polygon points="29,0 58,50 29,50" [attr.fill]="rightFill()" />
    @if (isClassicStyle()) {
      <polygon
        points="29,0 58,50 0,50"
        fill="none"
        [attr.stroke]="borderColor()"
        stroke-width="1"
        stroke-linejoin="round"
        vector-effect="non-scaling-stroke"
      />
    }
  </svg>
  <span class="shape-number tone-number" [style.color]="numberColor()" [style.text-shadow]="numberTextShadow()">{{ toneNumber() }}</span>
</div>
